import { defineMessages } from 'react-intl-next';

export const i18n: {
	errorLoading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorBoundaryFallback: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noIncompleteTasksTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noCompleteTasksTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	emptyDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnDueDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnAssignee: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnLocation: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnCompleteDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	columnLabels: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	completeTaskError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	completeTaskLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortAscending: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sortDescending: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	paginationPrevious: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	paginationNext: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noSpacesSelectedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noSpacesSelectedDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorLoading: {
		id: 'tasks-report-macro.error.loading',
		defaultMessage: 'Failed to load tasks. Please try again.',
		description: 'Error shown when the GraphQL request fails',
	},
	errorBoundaryFallback: {
		id: 'tasks-report-macro.error.boundary-fallback',
		defaultMessage: 'Something went wrong loading the tasks report.',
		description: 'Fallback message shown when the tasks report macro crashes during render',
	},
	noIncompleteTasksTitle: {
		id: 'tasks-report-macro.empty.incomplete.title',
		defaultMessage: 'No incomplete tasks found',
		description: 'Title shown in the empty state when no incomplete tasks match the filter',
	},
	noCompleteTasksTitle: {
		id: 'tasks-report-macro.empty.complete.title',
		defaultMessage: 'No complete tasks found',
		description: 'Title shown in the empty state when no complete tasks match the filter',
	},
	emptyDescription: {
		id: 'tasks-report-macro.empty.description',
		defaultMessage: 'Try adjusting your filters to find tasks.',
		description: 'Description shown in the empty state',
	},
	columnDescription: {
		id: 'tasks-report-macro.column.description',
		defaultMessage: 'Description',
		description: 'Column header for the task description',
	},
	columnDueDate: {
		id: 'tasks-report-macro.column.duedate',
		defaultMessage: 'Due Date',
		description: 'Column header for the task due date',
	},
	columnAssignee: {
		id: 'tasks-report-macro.column.assignee',
		defaultMessage: 'Assignee',
		description: 'Column header for the task assignee',
	},
	columnLocation: {
		id: 'tasks-report-macro.column.location',
		defaultMessage: 'Task Appears on',
		description: 'Column header for the task container page/blog post',
	},
	columnCompleteDate: {
		id: 'tasks-report-macro.column.completedate',
		defaultMessage: 'Completed',
		description: 'Column header for the task completion date',
	},
	columnLabels: {
		id: 'tasks-report-macro.column.labels',
		defaultMessage: 'Label(s)',
		description: 'Column header for task label(s) in the tasks report table',
	},
	completeTaskError: {
		id: 'tasks-report-macro.task.complete.error',
		defaultMessage: 'Failed to mark task as complete. Please try again.',
		description: 'Inline error message shown when completing a task fails',
	},
	completeTaskLabel: {
		id: 'tasks-report-macro.task.complete.label',
		defaultMessage: 'Mark task as complete',
		description: 'Accessible label for the complete task checkbox',
	},
	sortAscending: {
		id: 'tasks-report-macro.sort.ascending',
		defaultMessage: 'Sort ascending',
		description: 'Sort direction label for ascending sort',
	},
	sortDescending: {
		id: 'tasks-report-macro.sort.descending',
		defaultMessage: 'Sort descending',
		description: 'Sort direction label for descending sort',
	},
	paginationPrevious: {
		id: 'tasks-report-macro.pagination.previous',
		defaultMessage: 'Prev',
		description: 'Pagination control to navigate to the previous page in task report table',
	},
	paginationNext: {
		id: 'tasks-report-macro.pagination.next',
		defaultMessage: 'Next',
		description: 'Pagination control to navigate to the next page in task report table',
	},
	noSpacesSelectedTitle: {
		id: 'tasks-report-macro.empty.nospacesselected.title',
		defaultMessage: 'No spaces selected',
		description: 'Title shown in the empty state when no spaces are selected in the macro',
	},
	noSpacesSelectedDescription: {
		id: 'tasks-report-macro.empty.nospacesselected.description',
		defaultMessage: 'Configure the macro and select which spaces to search for tasks.',
		description: 'Description shown in the empty state when no spaces are selected',
	},
});
